import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: 'app-image-chip',
    templateUrl: './image-chip.component.html',
    styleUrls: ['./image-chip.component.css']
})
export class ImageChipComponent {
    @Input() url: string = '';
    @Input() altText: string = '';
    @Input() displayText: string = '';
    @Input() clickable: boolean = true;

    @Output() clicked = new EventEmitter<void>();

    loaded: boolean = false;
    error: boolean = false;

    constructor() { };

    onClick(): void {
        if (!this.clickable) {
            return;
        }

        this.clicked.emit();
    };

    onLoad(): void {
        this.loaded = true;
    };

    onError(): void {
        this.loaded = true;
        this.clickable = false;
        this.error = true;
    };
};
